import React from "react";
import CustomRoutes from "../../customRoutes";
import Login from "./login";
import OtpScreen from "./otp";
import {
	IonPage,
	IonHeader,
	IonToolbar,
	IonContent,
	IonSlides,
	IonSlide,
	IonImg,
	IonGrid,
	IonRow,
	IonCol,
	IonLabel,
	IonButton,
	useIonLoading,
	isPlatform,
} from "@ionic/react";
import "../../global.scss";
import {
	SKIP_FOR_NOW,
	BOOK_CAR_SERVICE,
	BEST_CAR_SERVICE,
	EXCITING_REWARDS,
	REWARDING_TEXT,
	DOCUMENT_VAULT,
	DOCUMENT_VAULT_TEXT,
	LOGIN_OR_SIGNUP,
	MOBILE_NUMBER,
	OTP_TEXT,
	CONTINUE,
	CONTINUE_USING_MOBILENUM,
	OR_LOGIN_WITH,
	OR,
	GOOGLE,
	FACEBOOK,
	APPLE,
	BY_CONTINUE,
	T_AND_C,
	PRIVACY_POLICY,
	TC_TSERV_LINK,
	PP_TSERV_LINK,
	CERTIFIED_TECHNICIANS,
	CERTIFIED_TECHNICIANS_TEXT,
	CONVENIENCE,
	CONVENIENCE_TEXT,
	QUALITY_SERVICE,
	QUALITY_SERVICE_TEXT,
} from "../../constants";
import {
	COLLECTIONS,
	signInAnonymously,
	signInWithApple,
	// signInWithFaceBook,
	signInWithGoogle,
	updateDoc,
} from "../../firebase";
import { SocialIcons } from "../CustomComponents/SocialIcons";
import { GetApp } from "../CustomComponents/GetApp";
import { HorizontalSlides } from "../CustomComponents/HorizontalSlides";
import PersonalDetails from "../OnBoarding/PersonalDetails";
import MobilenumberInput from "./mobilenumber";
import { ToastMessage } from "../../utils/toastMessage";
import { Loader } from "../../utils/loader";
import { signIn } from "../../Store/Actions";
import { connect } from "react-redux";

const LoginIndex: React.FC = (props: any) => {
	const { path } = props.match;
	const [state, setState] = React.useState(Boolean);
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	const [loader, showLoader] = React.useState(false);
	const [present] = useIonLoading();

	React.useEffect(() => {
		checkMediaQuery();
	}, [state]);

	function checkMediaQuery() {
		const mediaQuery = window.matchMedia("(max-width: 700px)");
		if (mediaQuery) {
			setState(mediaQuery.matches);
		}
	}

	function formatError(error: string, providerId?: string) {
		// console.log("Error ... 92 ===", error);
		if (error.includes("auth/")) {
			const splitted = error.split("/");
			if (splitted && splitted.length === 2) {
				let toastText = splitted[1].split("-").join(" ");
				setToast({
					showToast: true,
					toastMessage: toastText[0].toUpperCase() + toastText.slice(1).toLowerCase(),
					severity: "danger",
				} as any);
				return;
			}
		} else {
			if (error) {
				const uid = JSON.parse(atob(error.split(".")[1]));
				const { user_id } = uid;
				updateDoc(user_id, { providerId: providerId }, COLLECTIONS.USERS);
				props.signIn({
					providerId: providerId,
				});
			}
		}
	}

	window.addEventListener("resize", checkMediaQuery);
	const slidesArray = [
		// {
		//   image: "/images/carService.svg",
		//   label1: BOOK_CAR_SERVICE,
		//   label2: BEST_CAR_SERVICE,
		// },
		{
			image: "/images/quality_service.png",
			label1: QUALITY_SERVICE,
			label2: QUALITY_SERVICE_TEXT,
		},
		{
			image: "/images/convenience.png",
			label1: CONVENIENCE,
			label2: CONVENIENCE_TEXT,
		},
		{
			image: "/images/certified_technicians.png",
			label1: CERTIFIED_TECHNICIANS,
			label2: CERTIFIED_TECHNICIANS_TEXT,
		},
		// {
		//   image: "/images/carRewards.svg",
		//   label1: EXCITING_REWARDS,
		//   label2: REWARDING_TEXT,
		// },
		// {
		//   image: "/images/vault.svg",
		//   label1: DOCUMENT_VAULT,
		//   label2: DOCUMENT_VAULT_TEXT,
		// },
	];

	return (
		<IonPage className="loginDetails">
			<IonHeader className="banner_mobile">
				<IonToolbar className="header-toolbar">
					<img
						src="/images/carguys_logo.png"
						// src="/images/valuePlus_logo.png"
						// src="/images/t-serv-logo.png"
						onClick={() => props.history.push("/portal/dashboard")}
						className="headerLogo"
					/>
				</IonToolbar>
			</IonHeader>
			<IonContent color="#E5E5E5" forceOverscroll={false}>
				{/* <div className="login1 skip_now">
          <IonButton
            className="login3"
            onClick={async () => {
              showLoader(true);
              const result = await signInAnonymously();
              if (result.isError) {
                showLoader(false);
                formatError(result);
              }
            }}
            fill="clear"
          >
            {SKIP_FOR_NOW}
          </IonButton>
        </div> */}

				<IonGrid className="pd_0">
					<IonRow className="login6">
						<IonCol
							className="login4"
							style={{
								display:
									props.history.location.pathname === "/otp" && state ? "none" : "",
							}}
						>
							<HorizontalSlides slideArray={slidesArray} />
						</IonCol>
						<IonCol
							className="login_col"
							style={{
								height: props.history.location.pathname === "/otp-verify" ? "90vh" : "",
							}}
						>
							<CustomRoutes
								routes={[
									{
										path: `/login`,
										component: Login,
									},
									{
										path: `/otp-verify`,
										component: MobilenumberInput,
									},
									{
										path: "/otp",
										component: OtpScreen,
									},
								]}
								exact={{
									path: `${path}`,
									route: `/login`,
								}}
								// role={role}
							/>
							<div
								className="login26 marginT_marginB"
								style={{
									display:
										props.history.location.pathname === "/otp" && state ? "none" : "",
									visibility: isPlatform("ios") ? "hidden" : "visible",
								}}
							>
								{/* {!isPlatform("ios") && ( */}
								<div className="login28" />
								<IonLabel className="login27" color="tertiary">
									{OR_LOGIN_WITH}
								</IonLabel>
								<IonLabel className="onlyOr" color="tertiary">
									{OR}
								</IonLabel>
								<div className="login28" />
								{/* )} */}
							</div>
							{!isPlatform("ios") && (
								<div
									className="login29"
									style={{
										display:
											props.history.location.pathname === "/otp" && state ? "none" : "",
									}}
								>
									<SocialIcons
										{...props}
										imgpath="/images/google.svg"
										label={GOOGLE}
										onClick={async () => {
											const result = await signInWithGoogle();
											formatError(result, "google.com");
										}}
										isDisabled={props.tcChecked ? false : true}
									/>
									{/* <SocialIcons
                  {...props}
                  imgpath="/images/facebook.svg"
                  label={FACEBOOK}
                  onClick={async () => {
                    const result = await signInWithFaceBook();
                    formatError(result);
                  }}
                  isDisabled={props.tcChecked ? false : true}
                /> */}
									{isPlatform("ios") && (
										<SocialIcons
											imgpath="/images/apple.svg"
											label={APPLE}
											onClick={async () => {
												const result = await signInWithApple();
												formatError(result);
											}}
											isDisabled={props.tcChecked ? false : true}
										/>
									)}
								</div>
							)}
							<div
								style={{
									display:
										props.history.location.pathname === "/otp" && state ? "none" : "",
								}}
							>
								<IonLabel className="tcText" color="grey">
									{BY_CONTINUE}
									<span
										className="tcTextDiff"
										onClick={() => window.open(TC_TSERV_LINK, "_blank")}
									>
										{T_AND_C}
									</span>{" "}
									&{" "}
									<span
										className="tcTextDiff"
										onClick={() => window.open(PP_TSERV_LINK, "_blank")}
									>
										{PRIVACY_POLICY}
									</span>
								</IonLabel>
							</div>
							{!isPlatform("ios") && !isPlatform("android") && <GetApp />}
						</IonCol>
					</IonRow>
				</IonGrid>
				<ToastMessage
					showToast={toast.showToast}
					ToastMessage={toast.toastMessage}
					severity={toast.severity}
					onDidDismiss={() => {
						setToast({
							showToast: false,
							toastMessage: "",
							severity: "",
						});
					}}
				/>
				{loader ? <Loader loader={loader} /> : null}
			</IonContent>
		</IonPage>
	);
};

export default connect(
	({ auth: { tcChecked } }: any) => {
		return { tcChecked };
	},
	{ signIn }
)(LoginIndex);
